import { render, staticRenderFns } from "./FlagBelgium.vue?vue&type=template&id=6f52586c&"
import script from "./FlagBelgium.vue?vue&type=script&lang=js&"
export * from "./FlagBelgium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports